import { type Metric, onCLS, onFCP, onINP, onLCP, onTTFB } from "web-vitals";

export const collectWebVitals = (sendMetrics: (metric: Metric) => void) => {
  onCLS(sendMetrics);
  onINP(sendMetrics);
  onFCP(sendMetrics);
  onLCP(sendMetrics);
  onTTFB(sendMetrics);
};
